import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';

/**
 * How many receipts "Send all unsent" would act on (approved, unsent, with an
 * email or phone). Only fetched while the confirmation dialog is open, and
 * never cached, so the number shown is the number that will be sent.
 */
export function useUnsentCount(enabled: boolean) {
  return useQuery<number>({
    queryKey: queryKeys.receipts.unsentCount,
    queryFn: async () => {
      const res = await apiClient.get<{ count: number }>(endpoints.receipts.unsentCount);
      return res.data.count;
    },
    enabled,
    staleTime: 0,
    gcTime: 0,
  });
}
